import { render, staticRenderFns } from "./TagsSelect.vue?vue&type=template&id=1f2be624&scoped=true&"
import script from "./TagsSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./TagsSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2be624",
  null
  
)

export default component.exports